// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum BankCodeType {
  Bic = "BIC",
  Bik = "BIK",
  Au = "AU",
  Cc = "CC",
  Fw = "FW",
}
export default BankCodeType;
